import socketIOClient from './socketIO';

export const connectUserEvent = (data) =>
  socketIOClient.emit('ConnectUser', data);
